import { render, staticRenderFns } from "./safeguardDepartment.vue?vue&type=template&id=4d32d549&scoped=true"
import script from "./safeguardDepartment.vue?vue&type=script&lang=js"
export * from "./safeguardDepartment.vue?vue&type=script&lang=js"
import style0 from "./safeguardDepartment.vue?vue&type=style&index=0&id=4d32d549&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d32d549",
  null
  
)

export default component.exports